import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";
import { subscribeEmail } from "@/lib/api";

export const FinalCTA = ({ onReserve, shipDate }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Enter a valid email, operator.");
      return;
    }
    setLoading(true);
    try {
      const res = await subscribeEmail(email.trim());
      toast.success(res.message || "Enlisted.");
      setEmail("");
    } catch (err) {
      toast.error("Couldn't sign you up. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="final-cta" data-testid="final-cta-section" className="relative py-28 md:py-40 overflow-hidden">
      {/* ember glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[900px] rounded-full bg-sf-ember/15 blur-[120px]" />
      </div>
      <div className="absolute inset-0 sf-scanlines opacity-30" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <h2 className="sf-stencil text-5xl md:text-7xl text-sf-bone leading-[0.95]">
            Join the <span className="sf-ember-text">Frontline.</span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-sf-dim max-w-xl mx-auto">
            Reserve your deck before the first printing sells out. First-wave ships {shipDate}.
          </p>

          <button
            data-testid="final-cta-reserve-button"
            onClick={onReserve}
            className="mt-10 bg-gradient-to-r from-sf-emberDeep to-sf-emberBright text-white font-stencil uppercase tracking-[0.15em] text-lg px-10 py-5 rounded-sm hover:shadow-[0_0_36px_rgba(210,84,51,0.6)] transition-all hover:-translate-y-0.5"
          >
            Reserve My Deck
          </button>

          <div className="mt-14 max-w-md mx-auto">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-sf-muted mb-3">
              Not ready? Get launch updates.
            </p>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
              <input
                data-testid="email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ENTER YOUR EMAIL"
                className="flex-1 bg-sf-surface border border-sf-border rounded-sm px-4 py-3 text-sf-bone placeholder:text-sf-muted font-mono text-xs uppercase tracking-[0.15em] focus:outline-none focus:border-sf-ember transition-colors"
              />
              <button
                data-testid="email-submit-button"
                type="submit"
                disabled={loading}
                className="border border-sf-steel text-sf-bone font-stencil uppercase tracking-widest text-sm px-6 py-3 rounded-sm hover:bg-sf-steel/10 transition-colors disabled:opacity-70 flex items-center justify-center gap-2"
              >
                {loading ? <Loader2 className="animate-spin" size={16} /> : "Enlist"}
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
